const type = {
  SET_CARDS: "SET_CARDS",
  SET_NUMBER_OF_CARDS: "SET_NUMBER_OF_CARDS",
  TOGGLE_GRIDS_DROPDOWN: "TOGGLE_GRIDS_DROPDOWN",
  DISABLED_CARDS: "DISABLED_CARDS",
  FIRST_CLICKED_CARD: "FIRST_CLICKED_CARD",
  SECOND_CLICKED_CARD: "SECOND_CLICKED_CARD",
  SHUFFLE_CARDS: "SHUFFLE_CARDS",
  SHOW_CONGRATULATIONS_MODAL: "SHOW_CONGRATULATIONS_MODAL",
  HIDE_CONGRATULATIONS_MODAL: "HIDE_CONGRATULATIONS_MODAL",
  START_TIMER: "START_TIMER",
  STOP_TIMER: "STOP_TIMER",
  RESET_TIMER: "RESET_TIMER",
  UPDATE_TIMER: "UPDATE_TIMER",
  SET_TIMER_INTERVAL: "SET_TIMER_INTERVAL",
  NUMBER_OF_CARD_TURNS: "NUMBER_OF_CARD_TURNS",
  RESET_NUMBER_OF_CARD_TURNS: "RESET_NUMBER_OF_CARD_TURNS",
};

export default type;
